import React from 'react';
import SectionsList from '../../../features/sections/SectionsList';

const ProductCardSections = () => {
    return <SectionsList sectionLocation='productCard' />;
};

export default ProductCardSections;